import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
 HttpRequest,
 HttpHandler,
 HttpEvent,
 HttpInterceptor,
 HttpResponse,
} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { UtmService } from '@core/services/utm.service';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class UtmInterceptor implements HttpInterceptor {
 isPlatformBrowser!: boolean;

 constructor(
  private utmService: UtmService,
  public activatedRoute: ActivatedRoute,
  public router: Router,
  public dialog: MatDialog,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {
  this.isPlatformBrowser = isPlatformBrowser(platformId);
 }

 intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  const utmQueryString = this.utmService.utmQueryString;
  if (utmQueryString) {
   const _request = request.clone({
    setHeaders: {
     'X-UTM-QueryString': utmQueryString,
    },
   });

   const requestHeaders: Record<string, string | null> = {};
   _request.headers.keys().forEach((key) => {
    requestHeaders[key] = _request.headers.get(key);
   });
//    console.log('[UtmInterceptor] request', {
//     url: _request.url,
//     method: _request.method,
//     utmQueryString,
//     headers: requestHeaders,
//    });

   return next.handle(_request).pipe(
    map((event: HttpEvent<any>) => {
     if (event instanceof HttpResponse) {
      const rsAffiliate = event.headers.get('Rs_affiliate') || event.headers.get('rs_affiliate');
      if (rsAffiliate) {
       this.utmService.setUtmImageSource(rsAffiliate);
      }
     }
     return event;
    })
   );
  }

  return next.handle(request);
 }
}
